import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { VERIFY_CAREGIVER_REQUEST } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  VerifyCaregiverRequestPayload,
  VerifyCaregiverRequestResult,
} from '../types/verifyCaregiverRequest.types';

export const verifyCaregiverRequest = (builder: BuilderType) =>
  builder.query<VerifyCaregiverRequestResult, VerifyCaregiverRequestPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: VERIFY_CAREGIVER_REQUEST,
    }),
    transformResponse: (response: GenericApiResponse<VerifyCaregiverRequestResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
